import { type JSX } from "react";
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export interface FilterState {
  search: string
  projectId: string | null
  calcStatus: string | null
}

interface FilterToolbarProps {
  filters: FilterState
  onFiltersChange: (filters: FilterState) => void
  projects: Array<{ id: string; name: string }>
}

export function FilterToolbar({ filters, onFiltersChange, projects }: FilterToolbarProps): JSX.Element {
  return (
    <div className="flex items-center gap-3">
      <Input
        placeholder="Search models..."
        value={filters.search}
        onChange={(e) => onFiltersChange({ ...filters, search: e.target.value })}
        className="h-8 w-56 text-sm"
      />
      <Select
        value={filters.projectId ?? '__all__'}
        onValueChange={(v) => onFiltersChange({ ...filters, projectId: v === '__all__' ? null : v })}
      >
        <SelectTrigger className="h-8 w-40 text-sm">
          <SelectValue placeholder="All Projects" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__all__">All Projects</SelectItem>
          {projects.map((p): JSX.Element => (
            <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={filters.calcStatus ?? '__all__'}
        onValueChange={(v) => onFiltersChange({ ...filters, calcStatus: v === '__all__' ? null : v })}
      >
        <SelectTrigger className="h-8 w-40 text-sm">
          <SelectValue placeholder="All Statuses" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__all__">All Statuses</SelectItem>
          <SelectItem value="converged">Converged</SelectItem>
          <SelectItem value="warnings">Warnings</SelectItem>
          <SelectItem value="partial">Partial</SelectItem>
          <SelectItem value="failed">Failed</SelectItem>
          <SelectItem value="none">Not Calculated</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}
